import Immutable from 'immutable';
import {
  HOME_PATH,
  FUEL_STATION_PATH,
  AGENCY_TO_FUEL_STATION_PATH,
  ITINERARY_GROUP_PATH,
  SEGMENT_PATH,
  CIRCUIT_PATH,
  ROUTE_PATH,
  ROUTE_DATA_PATH,
} from '../../../config/paths';

const INITIAL_STATE = Immutable.Map({
  cards: [
    {
      key: 'routes',
      title: 'Rutas',
      path: ROUTE_PATH,
      icon: 'exchange',
    },
    {
      key: 'segment',
      title: 'Segmentos',
      path: SEGMENT_PATH,
      icon: 'ellipsis-h',
    },
    {
      key: 'tolls',
      title: 'Peajes',
      path: '/route-management/tolls',
      icon: 'hand-stop-o',
      disabled: true,
    },
    {
      key: 'fuel-stations',
      title: 'Grifos',
      path: FUEL_STATION_PATH,
      icon: 'fire',
      disabled: false,
    },
    {
      key: 'circuits',
      title: 'Circuitos',
      path: CIRCUIT_PATH,
      icon: 'rotate-left',
    },
    {
      key: 'agency-to-fuel-station',
      title: 'Asignar Agencia a Grifo',
      path: AGENCY_TO_FUEL_STATION_PATH,
      icon: 'upload',
    },
    {
      key: 'itinerary-group',
      title: 'Grupos de Itinerarios por Circuito',
      path: ITINERARY_GROUP_PATH,
      icon: 'calendar',
    },
    {
      key: 'route-data',
      title: 'Exportar Datos de Rutas',
      path: ROUTE_DATA_PATH,
      icon: 'file-archive-o',
    },
  ],
  breadcrumbs: [
    {
      text: 'Inicio',
      tag: 'a',
      href: HOME_PATH,
    },
    {
      text: 'Gestión de Rutas',
      tag: 'span',
      href: '/route',
    },
  ],
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
